import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useCookieConsent } from '@/features/cookie-consent/hooks/use-cookie-consent'
import { CookieSettingsModal } from '@/features/cookie-consent/components/cookie-settings-modal'

import FooterSection from '../components/footer-section'
import CompanyInfo from '../components/company-info'
import WeChatModal from '../components/wechat-modal'
import { useFooterSections } from '../helpers/utils/sections'
import { FooterSectionText } from '../helpers/types/footer'

interface Props {
  label?: string
  logo: { url: string; alt: string }
  onClick?: (item: FooterSectionText) => void
  bottomMargin?: string
  bottomPaddingToAdd?: string
}

const GlobalFooter = ({
  label,
  logo,

  onClick,
  bottomMargin,
  bottomPaddingToAdd = '0px',
}: Props) => {
  const { showSettings, openSettings, closeSettings, saveCustomSettings, consent } = useCookieConsent()
  const { t } = useTranslation()
  const [showWeChatModal, setShowWeChatModal] = useState(false)
  const { aboutCompanySection, csSection } = useFooterSections(t, openSettings)
  const handleWeChatClick = () => {
    setShowWeChatModal(true)
  }

  return (
    <footer
      aria-label={label}
      className="box-border p-[30px] bg-[#f5f5f5] border-t-4 border-[#d6d6d6]"
      style={{
        marginBottom: bottomMargin ?? '',
        paddingBottom: `calc(30px + ${bottomPaddingToAdd})`,
      }}
    >
      <div className="w-[86px] h-[17.5px] mb-6">
        <img src={logo.url} alt={logo.alt} />
      </div>

      <FooterSection title={aboutCompanySection.title} textsList={aboutCompanySection.textsList} onClick={onClick} />

      <FooterSection title={csSection.title} textsList={csSection.textsList} onClick={onClick} />

      <CompanyInfo onWeChatClick={handleWeChatClick} />

      <CookieSettingsModal
        isOpen={showSettings}
        onClose={closeSettings}
        onSave={saveCustomSettings}
        currentSettings={consent?.settings}
      />
      <WeChatModal open={showWeChatModal} onOpenChange={setShowWeChatModal} />
    </footer>
  )
}

export default GlobalFooter
